import React, { useEffect, useState } from 'react'

import { Modal } from '@pb/components'
import { getLabelFromStorage } from '@pb/utils'
import { useDispatch } from 'react-redux'

import { operationConfirmAdyenCheckout } from 'features/checkout/duck/operations'

import { AdyenActionSubtypes, MOUNT_ID, HIDDEN_MOUNT_ID } from '../../constants'
import { completeAdyenCheckout } from '../../duck/actions'
import { AdyenActionHandlerProps } from '../../types'
import ChallengeModalLoader from '../ChallengeModalLoader'
import styles from './AdyenActionHandler.module.scss'

const AdyenActionHandler: React.FC<AdyenActionHandlerProps> = ({
  action,
  config,
  onChallengeModalClose,
  isSmallScreen,
}) => {
  const dispatch = useDispatch()

  const [isLoaderVisible, setIsLoaderVisible] = useState(true)
  const [mountedActionComponent, setMountedActionComponent] = useState()
  const handleOnAdditionalDetails = (state, component): void => {
    dispatch(
      operationConfirmAdyenCheckout({
        ...state.data.details,
        paymentData: component.props.paymentData,
      }),
    )
  }
  const checkForFingerPrintResults = (rawEvent: MessageEvent): void => {
    if (typeof rawEvent.data === 'string') {
      const data = JSON.parse(rawEvent.data)
      if (data.type === 'fingerPrintResult') {
        setIsLoaderVisible(false)
        window.removeEventListener('message', checkForFingerPrintResults, false)
      }
    }
  }
  const handleCloseClick = (): void => {
    if (mountedActionComponent) {
      // @ts-ignore the unmount method is provided through the injected SDK, code will not be reached if not 'mountedActionComponent'
      mountedActionComponent.unmount()
    }
    if (onChallengeModalClose) {
      onChallengeModalClose()
    } else {
      dispatch(completeAdyenCheckout())
    }
  }

  useEffect(() => {
    const createAdyenCheckout = async (): Promise<void> => {
      const checkoutConfig = {
        ...config,
        onAdditionalDetails: handleOnAdditionalDetails,
      }
      const checkout = await AdyenCheckout(checkoutConfig)

      const mountedComponent = checkout
        .createFromAction(action, {
          challengeWindowSize: isSmallScreen ? '01' : '02',
        })
        .mount(`#${action.subtype ? MOUNT_ID : HIDDEN_MOUNT_ID}`)

      setMountedActionComponent(mountedComponent)
    }

    try {
      createAdyenCheckout()
    } catch {
      handleCloseClick()
    }

    // To account for edge cases where the issuer's ACS has not configured a threeDSMethodURL (skips fingerprint and only does challenge)
    if (action.subtype === AdyenActionSubtypes.CHALLENGE) setIsLoaderVisible(false)

    if (action.subtype === AdyenActionSubtypes.FINGERPRINT) {
      window.addEventListener('message', checkForFingerPrintResults, false)
    }
    return () => {
      window.removeEventListener('message', checkForFingerPrintResults, false)
    }
  }, [action])

  return (
    <>
      <Modal
        closeButtonText={getLabelFromStorage('general.close')}
        isOpen={!!action.subtype}
        toggleModal={handleCloseClick}
        innerContainerClassName={styles.innerModalContainer}
        modalHeadingClassName={styles.modalHeading}
      >
        {isLoaderVisible && <ChallengeModalLoader />}
        <div id={MOUNT_ID} className={styles[MOUNT_ID]} />
      </Modal>
      <div id={HIDDEN_MOUNT_ID} className={styles[HIDDEN_MOUNT_ID]} />
    </>
  )
}

export default AdyenActionHandler
